export default __webpack_public_path__ + "static/media/sleepStudy.3b08f809.svg";